export default __webpack_public_path__ + "static/media/parking.bfd64f11.jpg";